import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import { AuthenticationService} from './authentication.service';
import { Observable, of } from 'rxjs';
import { catchError, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import { InterceptorSkipHeader } from './auth.constant';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root'
})


export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    public auth: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  if (request.headers.has(InterceptorSkipHeader)) {
    const headers = request.headers.delete(InterceptorSkipHeader);
    return next.handle(request.clone({ headers }));
  }

  return this.auth.getAccessToken().pipe(
    switchMap(accessToken => {

      const authReq = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          return this.handleAuthError(error);
        })
      );
    })
  );
}

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 0) {
      this.snackBar.open(
        'Bağlantı hatası oluştu. Lütfen biraz sonra tekrar deneyin.',
        'Kapat',
        { duration: 4000 }
      );
      return of(null);
    }
    throw err;


  }
}
